import * as turf from '@turf/turf';

export function findThirdPoint(pointA, pointB, distance) {
  const vectorAB = [pointB[0] - pointA[0], pointB[1] - pointA[1]];
  const magAB = Math.sqrt(vectorAB[0] ** 2 + vectorAB[1] ** 2);
  const normAB = [vectorAB[0] / magAB, vectorAB[1] / magAB];
  const scaledVector = [normAB[0] * distance, normAB[1] * distance];
  const pointC = [pointB[0] + scaledVector[0], pointB[1] + scaledVector[1]];
  return pointC;
}

export function calculateAngleBetweenPoints(pointA, pointB, pointC) {
  const vectorAB = [pointB[0] - pointA[0], pointB[1] - pointA[1]];
  const vectorBC = [pointC[0] - pointB[0], pointC[1] - pointB[1]];

  const angleAB = Math.atan2(vectorAB[1], vectorAB[0]);
  const angleBC = Math.atan2(vectorBC[1], vectorBC[0]);

  const angleRad = angleBC - angleAB;
  let angleDeg = turf.radiansToDegrees(angleRad);

  if (angleDeg < 0) {
    angleDeg += 360;
  }

  return angleDeg - 180;
}

export function calculateCoordinates(centerLng, centerLat, lengthFeet, widthFeet, rotation = 0) {
  const latDegPerFoot = 1 / 364000;
  const lngDegPerFoot = 1 / (364000 * Math.cos((centerLat * Math.PI) / 180));

  const latDiff = (lengthFeet / 2) * latDegPerFoot;
  const lngDiff = (widthFeet / 2) * lngDegPerFoot;

  const points = [
    { x: centerLng - lngDiff, y: centerLat + latDiff },
    { x: centerLng + lngDiff, y: centerLat + latDiff },
    { x: centerLng + lngDiff, y: centerLat - latDiff },
    { x: centerLng + -lngDiff, y: centerLat - latDiff }
  ];

  const bbox = [points[0].x, points[0].y, points[2].x, points[2].y];
  const bboxPolygon = turf.bboxPolygon(bbox);
  const rotatedPolygon = turf.transformRotate(bboxPolygon, rotation);
  const rotatedCoords = turf.getCoords(rotatedPolygon)[0].slice(0, 4);

  return {
    coordinates: rotatedCoords.map(point => [point[0], point[1]]),
    latDegPerFoot,
    lngDegPerFoot,
    latDiff,
    lngDiff
  };
}
